var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1760_305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.892578,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1760_305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.55924 10C7.32313 10 7.12522 10.0799 6.96549 10.2396C6.80577 10.3993 6.72591 10.5972 6.72591 10.8333V13.3333C6.72591 13.5694 6.80577 13.7674 6.96549 13.9271C7.12522 14.0868 7.32313 14.1667 7.55924 14.1667C7.79536 14.1667 7.99327 14.0868 8.15299 13.9271C8.31272 13.7674 8.39258 13.5694 8.39258 13.3333V10.8333C8.39258 10.5972 8.31272 10.3993 8.15299 10.2396C7.99327 10.0799 7.79536 10 7.55924 10ZM14.2259 5.83333C13.9898 5.83333 13.7919 5.91319 13.6322 6.07292C13.4724 6.23264 13.3926 6.43056 13.3926 6.66667V13.3333C13.3926 13.5694 13.4724 13.7674 13.6322 13.9271C13.7919 14.0868 13.9898 14.1667 14.2259 14.1667C14.462 14.1667 14.6599 14.0868 14.8197 13.9271C14.9794 13.7674 15.0592 13.5694 15.0592 13.3333V6.66667C15.0592 6.43056 14.9794 6.23264 14.8197 6.07292C14.6599 5.91319 14.462 5.83333 14.2259 5.83333ZM10.8926 11.6667C10.6565 11.6667 10.4586 11.7465 10.2988 11.9062C10.1391 12.066 10.0592 12.2639 10.0592 12.5V13.3333C10.0592 13.5694 10.1391 13.7674 10.2988 13.9271C10.4586 14.0868 10.6565 14.1667 10.8926 14.1667C11.1287 14.1667 11.3266 14.0868 11.4863 13.9271C11.6461 13.7674 11.7259 13.5694 11.7259 13.3333V12.5C11.7259 12.2639 11.6461 12.066 11.4863 11.9062C11.3266 11.7465 11.1287 11.6667 10.8926 11.6667ZM5.05924 17.5C4.60091 17.5 4.20855 17.3368 3.88216 17.0104C3.55577 16.684 3.39258 16.2917 3.39258 15.8333V4.16667C3.39258 3.70833 3.55577 3.31597 3.88216 2.98958C4.20855 2.66319 4.60091 2.5 5.05924 2.5H16.7259C17.1842 2.5 17.5766 2.66319 17.903 2.98958C18.2294 3.31597 18.3926 3.70833 18.3926 4.16667V15.8333C18.3926 16.2917 18.2294 16.684 17.903 17.0104C17.5766 17.3368 17.1842 17.5 16.7259 17.5H5.05924ZM10.8926 10C11.1287 10 11.3266 9.92014 11.4863 9.76042C11.6461 9.60069 11.7259 9.40278 11.7259 9.16667C11.7259 8.93056 11.6461 8.73264 11.4863 8.57292C11.3266 8.41319 11.1287 8.33333 10.8926 8.33333C10.6565 8.33333 10.4586 8.41319 10.2988 8.57292C10.1391 8.73264 10.0592 8.93056 10.0592 9.16667C10.0592 9.40278 10.1391 9.60069 10.2988 9.76042C10.4586 9.92014 10.6565 10 10.8926 10Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalytics);
export default __webpack_public_path__ + "static/media/icon_analytics.4ec96d850a861f996b4d1febff73fdc5.svg";
export { ForwardRef as ReactComponent };